import React from 'react'
import { Container, ContainerButton } from './styles'
import { Button } from '../Button'
import { PortalModal } from '~/components/shared/PortalModal'
import { IconComponent } from '~/assets/icons/component'

interface ModalAlertDevelopmentProps {
  showAlertDevelopmentModal: boolean
  onClose: () => void
  modalInfo: IsAlertDevelopmentModalProps
}
interface IsAlertDevelopmentModalProps {
  title?: string
  subtitle?: string
  buttonMessage?: string
}

export const ModalAlertDevelopment: React.FC<ModalAlertDevelopmentProps> = ({
  modalInfo,
  onClose,
  showAlertDevelopmentModal
}) => {
  if (!showAlertDevelopmentModal) return null
  return (
    <PortalModal
      size={'small'}
      useMask={false}
      show={showAlertDevelopmentModal}
      onClose={onClose}
      modalContainerProps={{
        style: { background: 'rgba(0, 0, 0, 0.3)' }
      }}
    >
      <Container>
        <IconComponent name="construction" />
        <h4>{modalInfo.title}</h4>
        <span>{modalInfo.subtitle}</span>
        <ContainerButton>
          <Button onClick={onClose} data-testid="alert-development-modal-close-button" minWidth="small">
            {modalInfo.buttonMessage}
          </Button>
        </ContainerButton>
      </Container>
    </PortalModal>
  )
}
